import {IntermediatePart} from "../../intermediatePart";

export default class BottomCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'bottom_cabinet';
    this.partName = 'Bottom Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.bottom_cabinet";
    this.hasAdditionalParts = true;
    this.layerPriority = 4;
    this.allWallsCanBeApplied = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    return super.load_(dbFeature, new BottomCabinet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    const cabinetParent = this.getParent();
    if (cabinetParent.cabinetLeg) {
      cabinetParent.cabinetLeg.disabled = this.disabled;
    }
    if (cabinetParent.countertop) {
      cabinetParent.countertop.disabled = this.disabled;
    }
    if (cabinetParent.bottomHandle) {
      cabinetParent.bottomHandle.disabled = this.disabled;
    }
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.bottomCabinet.activeFeature = this;
    }
    this.featureClicked();
  }

}
